import React from 'react';
import { Field } from '../../Api/interfaces';
import FieldType from './FieldType';
import './styles.css';

interface Props {
  field: Field;
  onTypeClicked?: (type: string) => void;
}

export default class FieldRow extends React.Component<Props> {
  render(): JSX.Element {
    const { field, onTypeClicked } = this.props;
    return (
      <tr>
        <td valign="top">
          <div id={field.name}>{field.name}</div>
        </td>
        <td valign="top">
          <div>{field.label}</div>
        </td>
        <td valign="top">
          <FieldType field={field} onTypeClicked={onTypeClicked} />
        </td>
        <td valign="top" className="checkBoxCell">
          <input type="checkbox" disabled checked={field.filterable} />
        </td>
        <td valign="top" className="checkBoxCell">
          <input type="checkbox" disabled checked={field.sortable} />
        </td>
        <td valign="top" className="checkBoxCell">
          <input type="checkbox" disabled checked={field.nullable} />
        </td>
      </tr>
    );
  }
}
